/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    if (!this.openDrawerViaEventHandler) {
      this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
      this.closeDrawerViaEventHandler = this.close.bind(this, null);
      this.boundCartRefreshHandler = this.cartRefreshHandler.bind(this);
      this.handleCartContent = () => {
        theme.manuallyLoadImages(this);
        this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
        this.querySelectorAll('.cart-price-summary__toggle').forEach((toggle) => {
          const target = this.querySelector(toggle.dataset.toggleTarget);
          if (target) toggle.setAttribute('aria-expanded', !target.classList.contains('toggle-target--hidden'));
        });
      };
      this.addEventListener('on:cart-drawer:before-open', this.handleCartContent);
      this.addEventListener('on:cart:after-merge', this.handleCartContent);
      this.addEventListener('keydown', (evt) => {
        if (evt.key === ' ' && evt.target.matches('.cart-price-summary__toggle')) evt.preventDefault();
      });
      this.addEventListener('keyup', (evt) => {
        if (evt.key === ' ' && evt.target.matches('.cart-price-summary__toggle')) {
          evt.preventDefault();
          evt.target.click();
        }
      });
    }
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.boundCartRefreshHandler);
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.boundCartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);
